export const educations = [
    {
      id: 1,
      title: "Bachelor of Technology in Computer Science & Engineering",
      duration: "2020 - 2024",
      institution: "I.K. Gujral Punjab Technical University, Kapurthala",
    },
    {
      id: 2,
      title: "Higher Secondary Education",
      duration: "2019-2020",
      institution: "New St. Soldier Sr. Secondary Public School, Jalandhar",
    },
    {
      id: 3,
      title: "Secondary School Education",
      duration: "2017-2018",
      institution: "New St. Soldier Sr. Secondary Public School, Jalandhar",
    }
  ]